// Integration of frontend and backend
import React from 'react';
import axios from 'axios';

// Configure axios defaults
const configureAxios = () => {
  // Set base URL for API requests
  axios.defaults.baseURL = ''; // same-origin: all calls already use /api/... paths
  
  // Add request interceptor to include auth token in all requests
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  // Add response interceptor to handle common errors
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Handle 401 Unauthorized errors (token expired or invalid)
      if (error.response && error.response.status === 401) {
        // Clear token and redirect to login
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
};

export default configureAxios;
